<ion-header class="ion-no-border ion-header-modal-mobile">
  <ion-toolbar>
    <ion-buttons
      *ngIf="selectedCreateInventoryOption?.code !== undefined"
      slot="start"
    >
      <ion-back-button
        data-cy="populate-inventory-modal-back-button"
        text=""
        (click)="goBack()"
      ></ion-back-button>
    </ion-buttons>
    <ion-label data-cy="populate-inventory-modal-title">
      {{ title | translate }}
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-content-modal-mobile">
  <!-- Inventory Options -->
  <app-populate-inventory-options
    *ngIf="
      selectedCreateInventoryOption?.code ===
      CreateInventoryModal.populateInventory
    "
    [inventoryConstants]="inventoryConstants | async"
    [selectedCreateInventoryOption]="selectedCreateInventoryOption"
    (selectCreateInventoryOptionEmitter)="onSelectCreateInventoryOption($event)"
  >
  </app-populate-inventory-options>
  <!-- Inventory Actions -->
  <!-- Past Inventories -->
  <app-past-inventories
    *ngIf="
      selectedCreateInventoryOption?.code === CreateInventoryModal.pastInventory
    "
    [platform]="platformService?.platformType"
    [inventories]="inventories | async"
    (selectInventoryEmitter)="onSelectInventory($event)"
    (searchInventoriesEmitter)="onSearchInventories($event)"
  ></app-past-inventories>
  <!-- Add Items Manually -->
  <app-add-items-manually
    *ngIf="selectedCreateInventoryOption?.code === CreateInventoryModal.manual"
    [platform]="platformService?.platformType"
  ></app-add-items-manually>
  <!-- Past Purchases -->
  <app-past-purchases
    *ngIf="
      selectedCreateInventoryOption?.code === CreateInventoryModal.pastPurchase
    "
    [platform]="platformService?.platformType"
    [selectedCreateInventoryOption]="selectedCreateInventoryOption"
    [validTimes]="validTimes"
    (selectPastPurchaseEmitter)="onPastPurchaseSelection($event)"
  ></app-past-purchases>
  <!-- Shopping Lists -->
  <app-shopping-lists
    *ngIf="
      selectedCreateInventoryOption?.code === CreateInventoryModal.shoppingList
    "
    [platform]="platformService?.platformType"
    [shoppingLists]="shoppingLists | async"
    (selectShoppingListEmitter)="onSelectShoppingList($event)"
    (searchShoppingListsEmitter)="onSearchShoppingLists($event)"
  ></app-shopping-lists>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        data-cy="populate-inventory-cancel-button"
        class="usf-outline-green-mobile-modal-button"
        (click)="dismissModal()"
      >
        {{ 'i18n.common.cancel' | translate }}
      </ion-button>
      <ion-button
        *ngIf="
          selectedCreateInventoryOption?.code !==
          CreateInventoryModal.populateInventory
        "
        data-cy="populate-inventory-modal-next-button"
        [ngClass]="
          nextButtonEnabled
            ? 'usf-fill-green-mobile-modal-button'
            : 'usf-fill-disabled-mobile-modal-button'
        "
        (click)="onClickNext()"
      >
        {{ 'i18n.inventory.next' | translate }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
